import noordhoffLogo from "assets/images/png/noordhofflogo.png";
import { HOME_PAGES_ROUTES, SIGNIN_PAGES_ROUTES } from "constants/routes";
import type React from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import { redirectToIdpLogout } from "utils/idp";
import { clearCookiesLogout } from "../../persistence/access";
import type { FooterProps } from "./Footer.model";
import {
  ImageContainer,
  List,
  StyleFooter,
  StyleLogo,
  StyleText,
  StyleTitle,
} from "./Footer.styled";

export const Footer: React.FC<FooterProps> = ({ dataCy }) => {
  const { t } = useTranslation("footer");
  const history = useHistory();

  const onLogout = () => {
    clearCookiesLogout();
    redirectToIdpLogout();
    history.push(SIGNIN_PAGES_ROUTES.SIGNIN_PAGE);
  };

  return (
    <StyleFooter data-cy={dataCy}>
      <ImageContainer>
        <StyleLogo alt="noordhoff-logo" src={noordhoffLogo} />
      </ImageContainer>
      <List>
        <StyleTitle>{t("studiemeister", "Studiemeister")}</StyleTitle>
        <Link to={HOME_PAGES_ROUTES.HOME_PAGE}>{t("myCourses")}</Link>
        <Link to={HOME_PAGES_ROUTES.HOME_PAGE}>{t("myAccount")}</Link>
        <div data-cy="logout-button" role="button" tabIndex={0} onMouseDown={onLogout}>
          <StyleText>{t("logout", "Logout")}</StyleText>
        </div>
      </List>
      <List>
        <StyleTitle>{t("overStudiemeister", "Over Studiemeister")}</StyleTitle>
        <a href="https://studiemeister.zendesk.com/hc/nl" rel="noreferrer" target="_blank">
          {t("knowledgeBase", "Zendesk Help Document")}
        </a>
        <a href="https://www.noordhoff.nl/privacy" rel="noreferrer" target="_blank">
          {t("privacyPolicy", "Privacy Statement")}
        </a>
        <a href="https://www.noordhoff.nl/noordhoff/voorwaarden" rel="noreferrer" target="_blank">
          {t("termsOfUse", "Terms & Conditions")}
        </a>
      </List>
      <List>
        <StyleTitle>{t("contact", "Contact")}</StyleTitle>
        <StyleText>{t("phone", "t. 088-5226830")}</StyleText>
        <StyleText>{t("address", "a. Verlengde Poolseweg 16 4818 CL Breda")}</StyleText>
      </List>
    </StyleFooter>
  );
};
